import React, { useEffect, useState } from 'react';
import { Box, BoxProps, List, ListItem } from '@mui/material';

interface SubMenuProps {
  list: string[];
  handleClick: (event: React.MouseEvent<HTMLElement>, key: string) => void;
  mainListRef: React.RefObject<{
    scrollToSection: (key: string) => void;
    container: HTMLDivElement | null;
  }>;
  itemRight?: boolean;
  containerProps?: BoxProps;
}

const SubMenu: React.FC<SubMenuProps> = ({
  list,
  handleClick,
  mainListRef,
  containerProps,
}) => {
  const { sx: containerSx, ...restContainerProps } = containerProps || {};
  const [currentItem, setCurrentItem] = useState<string>('A');

  useEffect(() => {
    const handleScroll = () => {
      const container = mainListRef.current?.container;
      if (container) {
        const offset = 180;
        const elements = container.querySelectorAll('[id^="section_"]');
        let newCurrentItem = 'A';

        elements.forEach((element) => {
          const rect = element.getBoundingClientRect();
          if (rect.top <= offset) {
            newCurrentItem = element.id.replace('section_', '');
          }
        });

        if (newCurrentItem !== currentItem) {
          setCurrentItem(newCurrentItem);
        }
      }
    };

    const container = mainListRef.current?.container;
    if (container) {
      container.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [currentItem]);
  return (
    <Box
      sx={{
        maxHeight: 'auto',
        overflowY: 'auto',
        '-ms-overflow-style': 'none',
        'scrollbar-width': 'none',
        '::-webkit-scrollbar': {
          width: '6px',
          display: 'none',
        },
        '::-webkit-scrollbar-thumb': {
          backgroundColor: '#31ACBF',
          borderRadius: '50px',
        },
        '::-webkit-scrollbar-thumb:hover': {
          background: '#31ACBF',
        },
        ...containerSx,
      }}
      {...restContainerProps}
    >
      <List>
        {list.map((text, index) => (
          <ListItem
            key={`desktop_initial_letter_${text}_${index}`}
            sx={{
              cursor: 'pointer',
              p: 2.5,
              justifyContent: 'center',
              backgroundColor:
                currentItem === text ? 'primary.main' : 'transparent',
              lineHeight: '.875rem',
              fontSize: '.875rem',
              fontWeight: 600,
              color: currentItem === text ? '#1E242F' : '#67708C',
            }}
            onClick={(event) => handleClick(event, text)}
          >
            {text}
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default SubMenu;
